import { createAsyncThunk } from '@reduxjs/toolkit';
import CommerceApiFetchWrapper from '/Foundation/Common/code/Utils/CommerceApiFetchWrapper';
import { setCartIdCookie } from '/Foundation/React/code/Utilities/HelperUtilities';
import { changeProductQty } from '../Slices/CartSlice.jsx';
import { getAnalyticsDataForCartProducts } from '/Foundation/Common/code/Helpers/TrackingHelper.js';
import { setEstimatedShippingOnCart } from '/Foundation/Common/code/Helpers/ShippingHelper.js';
import { br_cartAddition } from '/Foundation/Bloomreach/code/Events/BloomreachCart.js';

export const getCart = createAsyncThunk('getCart', async (_, { rejectWithValue }) => {
  let isB2CEnabled = _THULEDATA?.isB2CEnabled;
  if (!isB2CEnabled) return rejectWithValue('getCart failed due to B2C not being enabled for this market');

  let cart = await CommerceApiFetchWrapper('/cart/get-cart', { method: 'GET' });
  if (!cart) {
    setCartIdCookie(null);
    return rejectWithValue('getCart - no cart found.');
  }

  if (cart?.lineItems?.length > 0 && !cart.shippingInfo && window._THULEDATA._Cart?.showDelivery) {
    cart = await setEstimatedShippingOnCart();
  }

  // Get analytics data for all tracking + Update Adobe Data Layer with cart products
  await getAnalyticsDataForCartProducts(cart);

  return cart;
});

export const accessoryAddToCart = createAsyncThunk('accessoryAddToCart', async (productId, { rejectWithValue }) => {
  const body = {
    productIds: [productId],
    quantity: 1,
  };

  let updatedCart = await CommerceApiFetchWrapper('/cart/add-cart-line', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!updatedCart) {
    return rejectWithValue('accessoryAddToCart - failed to add line to cart.');
  }
  br_cartAddition(updatedCart);
  window.dispatchEvent(new Event('cart-updated'));

  return updatedCart;
});

export const accessoryUpdateQuantity = createAsyncThunk(
  'accessoryUpdateQuantity',
  async ({ id, quantity }, { dispatch, rejectWithValue }) => {
    const body = {
      LineItems: [
        {
          Id: id,
          Quantity: quantity,
        },
      ],
    };

    let updatedCart = await CommerceApiFetchWrapper('/cart/update-quantity', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    if (!updatedCart) {
      return rejectWithValue('accessoryUpdateQuantity - failed to update lineitem quantity in cart.');
    }

    dispatch(
      changeProductQty({
        productId: id,
        quantity: quantity,
      })
    );
    br_cartAddition(updatedCart);
    window.dispatchEvent(new Event('cart-updated'));
    br_cartAddition(updatedCart);
    return updatedCart;
  }
);
